import { __ } from "@wordpress/i18n";
import { InspectorControls, useBlockProps } from "@wordpress/block-editor";
import { TabPanel, Notice, ColorPalette } from "@wordpress/components";
import {
  PanelBody,
  ToggleControl,
  FormTokenField,
  SelectControl,
  RangeControl,
  RadioControl,
  Placeholder,
  TextControl,
  TextareaControl,
  Button,
} from "@wordpress/components";

import { Spinner } from "@wordpress/components";

import { file, pin } from "@wordpress/icons";
import { __experimentalNumberControl as ExperimentalNumberControl } from "@wordpress/components";
import {
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from "@wordpress/components";
import { useEffect, useState } from "react";

import useFeaturedImage from "./hooks/useFeaturedImage";
import useCptNamesAndPostsByName from "./hooks/useCptNamesAndPostsByName";
import Slider from "./layouts/Slider/Slider";
import Grid from "./layouts/grid/Grid";
import MasanoryLayout from "./layouts/Masanory/MasanoryLayout";
import OverlayLayout from "./layouts/Overlay/OverlayLayout";
import ListingLayoutTwo from "./layouts/listingTwo/ListingLayoutTwo";
import ListingLayout from "./layouts/listing/ListingLayout";
import useSortedData from "./hooks/useSortedData";
import WepPagination from "./components/WepPagination";
export default function Edit({ attributes, setAttributes }) {
 
  const {
    showImgToggler,
    showContent,
    showMeta,
    showPostTitle,
    numPostsToShow,
    selectedCustomPostType,
    wordsLimit,
    widthPercentage,
    valueForWidth,
    customTaxonomyPosts,
    sortBy,
    imageUrl,
    ImgWidth,
    height,
    contentType,
    widthController,
    totalColoms,
    columnGap,
    rowGap,
    PaginationOnToggler,
    prevName,
    nextName,
    commaSeparatedIds,
    RemoveCommaSeparatedIds,
    selectedLayout,
    paginationAline,
    showReadMoreToggler,
    ReadMoreBgColor,
    ReadMoreTextColor,
    button_Right_Left_Padding,
    button_Top_bottom_Padding,
    title_Manage_styling,
    title_font_size,
    Meta_Manage_styling,
    Meta_font_size,
    Content_Manage_styling,
    Content_font_size,
    Read_more_font_size,
    customCSS,
    ReadMoreText,
  } = attributes;

  const [page, setPage] = useState(1); // Current page state
  const perPage = numPostsToShow; // Posts per page
  const [errNotice, setErrNotice] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");
  const [withImagePosts, setWithImagePosts] = useState([]);
  const [tempCSS, setTempCSS] = useState(customCSS || "");
  const handleApplyCSS = () => {
    setAttributes({ ...attributes, customCSS: tempCSS });
  };

  // Function to remove the applied CSS
  const handleRemoveApplyCSS = () => {
    setTempCSS("");
    setAttributes({ ...attributes, customCSS: "" }); // Clear the saved customCSS
  };
  const {
    data,
    setData,
    fetchCustomTaxonomyIdsBytermName,
    handleSelectedCustomPostType,
    fetchPostsByIds,
    customPostsOptionsResponse,
    isLoading,
  } = useCptNamesAndPostsByName({ attributes, setAttributes });

  const {
    handleAlignmentChange,
    handleWidthChange,
    handleResolutionChange,
    handleHeightChange,
    getMaxHeightAndWidth,
    alignment,
    toggleGroupControlState,
  } = useFeaturedImage({ attributes, setAttributes });

  const truncateContent = (excerpt, limit) => {
    const words = excerpt?.split(" ");
    if (words.length > limit) {
      return words.slice(0, limit).join(" ") + "...";
    } else {
      return excerpt;
    }
  };
  // Call the custom hook with data, sortBy, and setData
  useSortedData(data, sortBy, setData);

  useEffect(() => {
    setAttributes({
      ...attributes,
      height: height,
      showImgToggler: showImgToggler,
      showContent: showContent,
      showPostTitle: showPostTitle,
      showMeta: showMeta,
    });
  }, [data, valueForWidth, height]);

  //Fetch Include-Posts:
  useEffect(() => {
    if (commaSeparatedIds.length > 0) {
      fetchPostsByIds(commaSeparatedIds);
    }
  }, [commaSeparatedIds, RemoveCommaSeparatedIds]);

  // Set ErrNotification:
  useEffect(() => {
    // Helper function to clean and sort an array of IDs
    const cleanAndSortIds = (arr) => {
      return arr
        .map((id) => id.replace(/\D/g, "")) // Remove non-numeric characters
        .filter((id) => id !== "") // Remove empty strings
        .map((id) => Number(id)) // Convert to numbers
        .sort((a, b) => a - b); // Sort numerically
    };

    // Clean and sort IDs from comma-separated strings
    const cleanedCommaIds = cleanAndSortIds(commaSeparatedIds);
    const cleanedRemoveIds = cleanAndSortIds(RemoveCommaSeparatedIds);

    // Remove duplicates
    const uniqueCommaIds = [...new Set(cleanedCommaIds)];
    const uniqueRemoveIds = [...new Set(cleanedRemoveIds)];

    // Check if the arrays are equal
    const arraysAreEqual =
      uniqueCommaIds.length > 0 &&
      uniqueRemoveIds.length > 0 &&
      uniqueCommaIds.length === uniqueRemoveIds.length &&
      uniqueCommaIds.every((id, index) => id === uniqueRemoveIds[index]);

    if (arraysAreEqual) {
      setErrNotice(true);
    } else {
      setErrNotice(false);
    }
  }, [RemoveCommaSeparatedIds]);

  useEffect(() => {
    if (selectedLayout === "overlay-layout") {
      const updatedPosts = data.map((item) => {
        // Flag for posts without images
        return {
          ...item,
          hasNoImage: !item.featured_image_url?.thumbnail, // If no image, flag as 'no-image'
        };
      });
      setWithImagePosts(updatedPosts); // Update the state with flagged posts
    } else if (selectedLayout === "slider-layout") {
      // Filter out items without an image for the slider layout
      const withImagePosts = data.filter(
        (item) => item.featured_image_url?.thumbnail
      );
      setWithImagePosts(withImagePosts); // Update the state with filtered posts
    } else {
      setWithImagePosts(data); // Default: set the posts normally for other layouts
    }
  }, [selectedLayout, data]); // Dependencies

  // Exclude Posts From FinalData(data):
  useEffect(() => {
    let newData = [];

    if (RemoveCommaSeparatedIds.length > 0) {
      // Filter data to exclude IDs in RemoveCommaSeparatedIds
      newData = data.filter(
        (item) => !RemoveCommaSeparatedIds.includes(item.id.toString())
      );
      if (JSON.stringify(newData) !== JSON.stringify(data)) {
        // Update state with the filtered data only if it has changed
        setData(newData);
      }
    }
  }, [data, RemoveCommaSeparatedIds]); // Dependencies to trigger effect

  // Define the component based on viewType
  let DynamicComponent;
  switch (selectedLayout) {
        case "slider-layout":
        DynamicComponent = Slider;
        break;
        case "overlay-layout":
        DynamicComponent = OverlayLayout;
        break;
        case "listing-layout":
        DynamicComponent = ListingLayout;
        break;
        case "listing-layout-two":
        DynamicComponent = ListingLayoutTwo;
        break;
        case "grid-layout":
        DynamicComponent = Grid;
        break;
        case "masanory-layout":
        default:
        DynamicComponent = MasanoryLayout;
        break;
  }

  // Handle tab change
  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
  };

  const handleSort = (selectedSortBy) => {
    setAttributes({ ...attributes, sortBy: selectedSortBy });
  };


  const handleIncludePosts = (value) => {
    if (!value.trim()) {
      setErrNotice(false);
      setAttributes({ commaSeparatedIds: [] });
    } else {
      const idsArray = value.split(",");
      setPage(1);
      setAttributes({ ...attributes, commaSeparatedIds: idsArray });
    }
  };

  const handleExcludePosts = (value) => {
    if (value.trim()) {
      const idsArray = value.split(",");
      setAttributes({ ...attributes, RemoveCommaSeparatedIds: idsArray });
    } else {
      setPage(1);
      setAttributes({ ...attributes, RemoveCommaSeparatedIds: [] });
    }
  };
  const handleChangeLayout = (layout) => {
    setAttributes({ ...attributes, selectedLayout: layout });
  };
  const alinePagination = (value) => {
    setAttributes({ ...attributes, paginationAline: value });
  };

  const selectedCustomPost =
    selectedCustomPostType === "Posts"
      ? "post"
      : selectedCustomPostType === "Pages"
      ? "page"
      : selectedCustomPostType.toLowerCase();
  const lowercaseSelectedCpt =
    customPostsOptionsResponse?.post_type_and_taxonomies?.[selectedCustomPost];

  // Pagination Data:
  const dataWithImages = withImagePosts.length > 0 ? withImagePosts : data;
  const paginatedData = PaginationOnToggler
    ? Array.isArray(dataWithImages)
      ? dataWithImages.slice((page - 1) * perPage, page * perPage)
      : []
    : Array.isArray(dataWithImages)
    ? dataWithImages.slice(0, numPostsToShow)
    : [];


  return (
    <div {...useBlockProps()}>
      {errNotice ? (
        <Notice status="error" isDismissible={false}>
          Please ensure IDs are not included in both the include and exclude
          lists.
        </Notice>
      ) : isLoading ? (
        <Placeholder
          label={__("Advanced Posts Listing", "advanced-posts-listing")}
        >
          <div>
            <Spinner />
            <span>{__("Loading...", "advanced-posts-listing")}</span>
          </div>
        </Placeholder>
      ) : data?.length === 0 ? (
        <Placeholder
          icon={pin}
          label={__("Advanced Posts Listing", "advanced-posts-listing")}
        >
          <p>{__("No posts were found.", "advanced-posts-listing")}</p>
        </Placeholder>
      ) : (
        <>
          <DynamicComponent
            paginatedData={paginatedData}
            numPostsToShow={numPostsToShow}
            showImgToggler={showImgToggler}
            showPostTitle={showPostTitle}
            showMeta={showMeta}
            showContent={showContent}
            contentType={contentType}
            truncateContent={truncateContent}
            wordsLimit={wordsLimit}
            imageUrl={imageUrl}
            valueForWidth={valueForWidth}
            widthPercentage={widthPercentage}
            widthController={widthController}
            ImgWidth={ImgWidth}
            height={height}
            columnGap={columnGap}
            rowGap={rowGap}
            totalColoms={totalColoms}
            __={__} // Ensure you pass any translation function or props needed
            ReadMoreBgColor={ReadMoreBgColor}
            showReadMoreToggler={showReadMoreToggler}
            ReadMoreTextColor={ReadMoreTextColor}
            button_Top_bottom_Padding={button_Top_bottom_Padding}
            button_Right_Left_Padding={button_Right_Left_Padding}
            title_Manage_styling={title_Manage_styling}
            title_font_size={title_font_size}
            Meta_Manage_styling={Meta_Manage_styling}
            Meta_font_size={Meta_font_size}
            Content_Manage_styling={Content_Manage_styling}
            Content_font_size={Content_font_size}
            Read_more_font_size={Read_more_font_size}
            customCSS={customCSS}
            ReadMoreText={ReadMoreText}
          />
        </>
      )}

      {data.length > 0 && data.length > numPostsToShow && (
        <div
          className="pagination-control"
          style={{
            marginTop: rowGap,
            display: "flex",
            justifyContent: paginationAline,
          }}
        >
          {PaginationOnToggler &&
            !errNotice &&
            selectedLayout !== "slider-layout" && (
              <>
                <WepPagination
                  attributes={attributes}
                  totalItems={dataWithImages.length}
                  itemsPerPage={perPage}
                  onPageChange={(newPage) => setPage(newPage)}
                />
              </>
            )}
        </div>
      )}
      <div>
        <InspectorControls>
          <TabPanel
            className="my-tab-panel"
            tabs={[
              {
                name: "Layouts",
                title: "Layouts",
                className: "tab-two",
              },
              {
                name: "General",
                title: "General",
                className: "tab-one",
              },

              {
                name: "Elements",
                title: "Elements",
                className: "tab-two",
              },
            ]}
            activeTab={activeTab}
            onSelect={handleTabChange}
          >
            {(tab) => <div></div>}
          </TabPanel>
        </InspectorControls>

        {/* Conditionally render the InspectorControls based on the active tab */}
        {activeTab === "Layouts" && (
          <InspectorControls>
            <PanelBody
              title={__("Select Layout", "advanced-posts-listing")}
              initialOpen={true}
            >
              <SelectControl
                className="apgb-post-type"
                label={__("Choose A Layout", "advanced-posts-listing")}
                value={selectedLayout}
                onChange={handleChangeLayout}
                options={[
                  { label: "Listing Layout ", value: "listing-layout" },
                  { label: "Listing Layout Two", value: "listing-layout-two" },
                  { label: "Grid Layout", value: "grid-layout" },
                  { label: "Overlay Layout", value: "overlay-layout" },
                  { label: "Masonry Layout", value: "masonry-layout" },
                  { label: "Slider Layout", value: "slider-layout" },
                ]}
              />
            </PanelBody>
          </InspectorControls>
        )}

        {activeTab === "Layouts" && selectedLayout !== "slider-layout" && (
          <InspectorControls>
            <PanelBody
              title={__("Layout Settings", "advanced-posts-listing")}
              initialOpen={false}
            >
              {selectedLayout !== "listing-layout" &&
                selectedLayout !== "slider-layout" &&
                selectedLayout !== "listing-layout-two" && (
                  <div
                    className="dashicons-before-range"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <span
                      class="dashicons dashicons-grid-view"
                      style={{ marginRight: "8px", marginTop: "-33px" }}
                    ></span>

                    <div className="rangeController" style={{ flex: 1 }}>
                      <RangeControl
                        label={__("No. Of Columns", "advanced-posts-listing")}
                        value={totalColoms}
                        max={6}
                        min={1}
                        onChange={(value) => {
                          setAttributes({ totalColoms: value });
                        }}
                        help={__(
                          "Set the number of columns to displayed in a row.",
                          "advanced-posts-listing"
                        )}
                      />
                    </div>
                  </div>
                )}
              {selectedLayout !== "listing-layout" &&
                selectedLayout !== "slider-layout" &&
                selectedLayout !== "listing-layout-two" &&
                
                totalColoms > 1 && (
                  <div
                    className="dashicons-before-range "
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div
                      className="dashicons dashicons-arrow-right-alt"
                      style={{ marginRight: "8px", marginTop: "-33px" }}
                    ></div>
                    <div className="rangeController" style={{ flex: 1 }}>
                      <RangeControl
                        label={__("Column Gap", "advanced-posts-listing")}
                        value={parseInt(columnGap)}
                        max={100}
                        min={1}
                        onChange={(value) => {
                          const updatedColomGap = `${value}px`;
                          setAttributes({ columnGap: updatedColomGap });
                        }}
                        className="custom-range-control"
                        help={__(
                          "Set the space to be applied between columns.",
                          "advanced-posts-listing"
                        )}
                      />
                    </div>
                  </div>
                )}

              {selectedLayout !== "slider-layout" && (
                <div
                  className="dashicons-before-range"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    className="dashicons dashicons-arrow-down-alt"
                    style={{ marginRight: "8px", marginTop: "-33px" }}
                  ></div>
                  <div className="rangeController" style={{ flex: 1 }}>
                    <RangeControl
                      label={__("Row Gap", "advanced-posts-listing")}
                      value={parseInt(rowGap)}
                      max={150}
                      min={1}
                      onChange={(value) => {
                        const updatedRowGap = `${value}px`;
                        setAttributes({ rowGap: updatedRowGap });
                      }}
                      className="custom-range-control"
                      help={__(
                        "Set the space to be applied between rows.",
                        "advanced-posts-listing"
                      )}
                    />
                  </div>
                </div>
              )}
            </PanelBody>
          </InspectorControls>
        )}

        <>
          {activeTab === "Layouts" && (
            <InspectorControls>
              <PanelBody
                title={__("Custom CSS", "advanced-posts-listing")}
                initialOpen={false}
              >
                <TextareaControl
                  __nextHasNoMarginBottom
                  help="Enter custom CSS"
                  onChange={(value) => setTempCSS(value)} // Update tempCSS as the user types
                  placeholder="Enter your CSS here"
                  value={tempCSS} // Controlled value linked to tempCSS state
                />
                <Button isPrimary onClick={handleApplyCSS}>
                  {__("Update CSS", "advanced-posts-listing")}
                </Button>

                {tempCSS && (
                  <Button
                    isSecondary
                    onClick={handleRemoveApplyCSS}
                    className="Remove-css"
                  >
                    {__("Remove CSS", "advanced-posts-listing")}
                  </Button>
                )}
              </PanelBody>
            </InspectorControls>
          )}
        </>
      </div>

      {activeTab === "General" && (
        <InspectorControls>
          <PanelBody
            title={__("Posts Count", "advanced-posts-listing")}
            initialOpen={false}
          >
            <RangeControl
              label="Number of Posts"
              value={numPostsToShow}
              min={1}
              onChange={(value) => {
                setAttributes({ numPostsToShow: value }); // Set numPostsToShow attribute
                setPage(1);
              }}
              help={__(
                "Set the maximum number of posts to display on the page",
                "advanced-posts-listing"
              )}
            />
          </PanelBody>
        </InspectorControls>
      )}

      {activeTab === "General" && (
        <InspectorControls>
          <PanelBody
            title={__("Data Source", "advanced-posts-listing")}
            initialOpen={false}
          >
            <SelectControl
              className="apgb-post-type"
              label={__("Post Type", "advanced-posts-listing")}
              value={selectedCustomPostType}
              onChange={handleSelectedCustomPostType}
              options={[
                { label: "Posts", value: "Posts" },
                { label: "Pages", value: "Pages" },
                ...(customPostsOptionsResponse &&
                  Object.keys(customPostsOptionsResponse.cpt_list || {}).map(
                    (key) => ({
                      label: customPostsOptionsResponse.cpt_list[key],
                      value: key,
                    })
                  )),
              ]}
            />

            {lowercaseSelectedCpt
              ?.filter(
                (taxonomy) =>
                  taxonomy.label !== "Pattern Categories" &&
                  taxonomy.label !== "Navigation Menus" &&
                  taxonomy.label !== "Formats"
              )
              .map((taxonomy, index) => {
                const lowercaseType =
                  taxonomy.label === "Categories"
                    ? "categories"
                    : taxonomy.label === "Tags"
                    ? "tags"
                    : taxonomy?.slug.toLowerCase();
                return (
                  <FormTokenField
                    className={`apgb-filter-by-${taxonomy.label}`}
                    key={taxonomy.label}
                    name={lowercaseType}
                    value={customTaxonomyPosts?.[lowercaseType] || []}
                    label={taxonomy.label}
                    onChange={(term) => {
                      fetchCustomTaxonomyIdsBytermName(
                        term,
                        lowercaseType,
                        index
                      );
                    }}
                  />
                );
              })}
          </PanelBody>
        </InspectorControls>
      )}
      {activeTab === "Elements" && (
        <InspectorControls>
          <PanelBody
            title={__("Post Title", "advanced-posts-listing")}
            initialOpen={false}
          >
            <ToggleControl
              checked={showPostTitle}
              label={__("Display Post Title", "advanced-posts-listing")}
              onChange={() =>
                setAttributes({
                  showPostTitle: !showPostTitle,
                })
              }
            />
            <ToggleControl
              checked={title_Manage_styling}
              label={__("Manage Styling", "advanced-posts-listing")}
              onChange={() =>
                setAttributes({
                  title_Manage_styling: !title_Manage_styling,
                })
              }
            />
            {title_Manage_styling && (
              <TextControl
                label={__(" Font Size ", "advanced-posts-listing")}
                help={__(
                  "Specify the font size using px, em, or rem (e.g., 15px, 20rem, 25em).",
                  "advanced-posts-listing"
                )}
                __nextHasNoMarginBottom
                value={title_font_size}
                onChange={(value) => {
                  setAttributes({ title_font_size: value });
                }}
              />
            )}
          </PanelBody>
        </InspectorControls>
      )}
      {activeTab === "Elements" && (
        <InspectorControls>
          <PanelBody
            title={__("Post Content", "advanced-posts-listing")}
            initialOpen={false}
          >
            <ToggleControl
              checked={showContent}
              label={__("Display Post Content", "advanced-posts-listing")}
              onChange={() =>
                setAttributes({
                  showContent: !showContent,
                })
              }
            />
            <ToggleControl
              checked={Content_Manage_styling}
              label={__("Manage Styling", "advanced-posts-listing")}
              onChange={() =>
                setAttributes({
                  Content_Manage_styling: !Content_Manage_styling,
                })
              }
            />
            {Content_Manage_styling && (
              <TextControl
                label={__(" Font Size ", "advanced-posts-listing")}
                help={__(
                  "Specify the font size using px, em, or rem (e.g., 15px, 20rem, 25em).",
                  "advanced-posts-listing"
                )}
                __nextHasNoMarginBottom
                value={Content_font_size}
                onChange={(value) => {
                  setAttributes({ Content_font_size: value });
                }}
              />
            )}
            {showContent && (
              <>
                <RadioControl
                  label={__("Display :", "advanced-posts-listing")}
                  selected={contentType}
                  options={[
                    { label: "Display Excerpt", value: "Excerpt" },
                    { label: "Display Full Post Content", value: "Full-Post" },
                  ]}
                  onChange={(newContentType) =>
                    setAttributes({ contentType: newContentType })
                  }
                />
                {contentType === "Excerpt" ? (
                  <RangeControl
                    label={__("Max Number of Words", "advanced-posts-listing")}
                    value={wordsLimit}
                    min={10}
                    onChange={(value) => {
                      setAttributes({ wordsLimit: value });
                    }}
                  />
                ) : null}
              </>
            )}
          </PanelBody>
        </InspectorControls>
      )}
      {activeTab === "Elements" && (
        <InspectorControls>
          <PanelBody
            title={__("Post Meta", "advanced-posts-listing")}
            initialOpen={false}
          >
            <ToggleControl
              checked={showMeta}
              label={__("Display Post Meta Info")}
              onChange={() =>
                setAttributes({
                  showMeta: !showMeta,
                })
              }
            />
            <ToggleControl
              checked={Meta_Manage_styling}
              label={__("Manage Styling", "advanced-posts-listing")}
              onChange={() =>
                setAttributes({
                  Meta_Manage_styling: !Meta_Manage_styling,
                })
              }
            />
            {Meta_Manage_styling && (
              <TextControl
                label={__(" Font Size ", "advanced-posts-listing")}
                help={__(
                  "Specify the font size using px, em, or rem (e.g., 15px, 20rem, 25em).",
                  "advanced-posts-listing"
                )}
                __nextHasNoMarginBottom
                value={Meta_font_size}
                onChange={(value) => {
                  setAttributes({ Meta_font_size: value });
                }}
              />
            )}
          </PanelBody>
        </InspectorControls>
      )}
      {activeTab === "Elements" && selectedLayout !== "overlay-layout" && selectedLayout !== "slider-layout"  && (
        <InspectorControls>
          <PanelBody
            title={__("Featured Image", "advanced-posts-listing")}
            initialOpen={false}
          >
            {selectedLayout !== "slider-layout" &&
              selectedLayout !== "overlay-layout" && (
                <ToggleControl
                  checked={showImgToggler}
                  label={__("Display Featured Image", "advanced-posts-listing")}
                  onChange={() =>
                    setAttributes({
                      showImgToggler: !showImgToggler,
                    })
                  }
                />
              )}
        
        {selectedLayout === "listing-layout"  && (
              <div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <ExperimentalNumberControl
                    label={__("Width", "advanced-posts-listing")}
                    value={parseInt(valueForWidth ? widthPercentage : ImgWidth)} // ParseInt to ensure numerical value
                    max={getMaxHeightAndWidth(attributes.imageUrl)} // ParseInt for max value
                    onChange={handleWidthChange}
                  />
                  <ExperimentalNumberControl
                    label={__("Height", "advanced-posts-listing")}
                    value={parseInt(valueForWidth ? widthPercentage : height)} // ParseInt to ensure numerical value
                    max={getMaxHeightAndWidth(attributes.imageUrl)} // ParseInt for max value
                    onChange={handleHeightChange}
                  />
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>
                    <ToggleGroupControl
                      label={__("IMAGE SIZE (%)", "advanced-posts-listing")}
                      value={
                        toggleGroupControlState === true ? "center" : alignment
                      }
                      style={{ width: "230px" }}
                      onChange={handleAlignmentChange}
                      help={__(
                        "Select the image size as a percentage.",
                        "advanced-posts-listing"
                      )}
                    >
                      <ToggleGroupControlOption value="left" label="25%" />
                      <ToggleGroupControlOption value="center" label="50%" />
                      <ToggleGroupControlOption value="right" label="75%" />
                      <ToggleGroupControlOption value="justify" label="100%" />
                    </ToggleGroupControl>
                  </div>
                </div>
              </div>
            )}
          </PanelBody>
        </InspectorControls>
      )}

      {activeTab === "Elements" && (
        <InspectorControls>
          <PanelBody
            title={__("Buttons", "advanced-posts-listing")}
            initialOpen={false}
          >
            <ToggleControl
              checked={showReadMoreToggler}
              label={__("Enable Custom Styling", "advanced-posts-listing")}
              onChange={() =>
                setAttributes({
                  showReadMoreToggler: !showReadMoreToggler,
                })
              }
            />
            {showReadMoreToggler && (
              <>
                <div>
                  <label className="Read-more-Text ">
                    {__("Text Color:", "advanced-posts-listing")}
                  </label>
                  <ColorPalette
                    value={ReadMoreTextColor}
                    onChange={(newColor) => {
                      setAttributes({
                        ReadMoreTextColor: newColor,
                      });
                    }}
                  />
                </div>

                <div>
                  <label className="Read-more-Text ">
                    {__("Background Color:", "advanced-posts-listing")}
                  </label>
                  <ColorPalette
                    value={ReadMoreBgColor}
                    onChange={(newColor) => {
                      setAttributes({
                        ReadMoreBgColor: newColor,
                      });
                    }}
                  />
                  <RangeControl
                    label={__("Top-Bottom Padding", "advanced-posts-listing")}
                    value={parseInt(button_Top_bottom_Padding)}
                    onChange={(value) => {
                      const updatedTopBottom = `${value}px`;
                      setAttributes({
                        button_Top_bottom_Padding: updatedTopBottom,
                      });
                    }}
                  />
                  <RangeControl
                    label={__("Left-Right Padding", "advanced-posts-listing")}
                    value={parseInt(button_Right_Left_Padding)}
                    onChange={(value) => {
                      const updatedRightLeft = `${value}px`;
                      setAttributes({
                        button_Right_Left_Padding: updatedRightLeft,
                      });
                    }}
                  />
                  <TextControl
                    label={__(" Font Size ", "advanced-posts-listing")}
                    help={__(
                      "Specify the font size using px, em, or rem (e.g., 15px, 20rem, 25em).",
                      "advanced-posts-listing"
                    )}
                    __nextHasNoMarginBottom
                    value={Read_more_font_size}
                    onChange={(value) => {
                      setAttributes({ Read_more_font_size: value });
                    }}
                  />
                </div>
              </>
            )}
            <TextControl
              label={__(" Update Button label ", "advanced-posts-listing")}
              __nextHasNoMarginBottom
              value={ReadMoreText}
              onChange={(value) => {
                setAttributes({ ReadMoreText: value });
              }}
            />
          </PanelBody>
        </InspectorControls>
      )}
      {activeTab === "General" && (
        <InspectorControls>
          <PanelBody
            title={__("Posts Sorting", "advanced-posts-listing")}
            initialOpen={false}
          >
            <>
              <SelectControl
                label={__("SORT BY", "advanced-posts-listing")}
                options={[
                  { label: "Newest To Oldest", value: "new-to-old" },
                  { label: "Oldest To Newest", value: "old-to-new" },
                  { label: "A - Z", value: "A-Z" },
                  { label: "Z - A", value: "Z-A" },
                ]}
                value={sortBy}
                onChange={handleSort}
              />
            </>
          </PanelBody>
        </InspectorControls>
      )}
      {activeTab === "General" && (
        <InspectorControls>
          <PanelBody
            title={__("Include & Exclude Posts", "advanced-posts-listing")}
            initialOpen={false}
          >
            <TextControl
              label={__("INCLUDE POSTS", "advanced-posts-listing")}
              value={commaSeparatedIds}
              onChange={handleIncludePosts}
              help={__(
                "Enter the comma seperated ids of posts Ex: 23,45,16 to be included. Only these will be displayed.",
                "advanced-posts-listing"
              )}
            />
            <TextControl
              label={__("EXCLUDE POSTS", "advanced-posts-listing")}
              value={RemoveCommaSeparatedIds.join(",")}
              onChange={handleExcludePosts}
              help={__(
                "Enter the comma seperated ids of posts to be excluded from result set Ex: 23,45",
                "advanced-posts-listing"
              )}
            />
          </PanelBody>
        </InspectorControls>
      )}
      {activeTab === "General" && selectedLayout !== "slider-layout" && (
        <InspectorControls>
          <PanelBody
            title={__("Pagination Settings", "advanced-posts-listing")}
            initialOpen={false}
          >
            <ToggleControl
              checked={!!PaginationOnToggler}
              label={__("Turn on pagination", "advanced-posts-listing")}
              onChange={() =>
                setAttributes({
                  PaginationOnToggler: !PaginationOnToggler,
                })
              }
            />

            {PaginationOnToggler && (
              <TextControl
                label={__("Add Prev Label", "advanced-posts-listing")}
                value={prevName}
                onChange={(value) => setAttributes({ prevName: value })}
                help={__(
                  "Text for the previous page button.",
                  "advanced-posts-listing"
                )}
              />
            )}
            {PaginationOnToggler && (
              <TextControl
                label={__("Add Next Label", "advanced-posts-listing")}
                value={nextName}
                onChange={(value) => setAttributes({ nextName: value })}
                help={__(
                  "Text for the next page button.",
                  "advanced-posts-listing"
                )}
              />
            )}

            {PaginationOnToggler && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <ToggleGroupControl
                    label={__("Pagination Alignment", "advanced-posts-listing")}
                    value={paginationAline}
                    style={{ width: "230px" }}
                    onChange={alinePagination}
                    help={__(
                      "Select the alignment for pagination controls.",
                      "advanced-posts-listing"
                    )}
                  >
                    <ToggleGroupControlOption value="left" label="Left" />
                    <ToggleGroupControlOption value="center" label="Center" />
                    <ToggleGroupControlOption value="right" label="Right" />
                  </ToggleGroupControl>
                </div>
              </div>
            )}
          </PanelBody>
        </InspectorControls>
      )}
    </div>
  );
}
